import { render, staticRenderFns } from "./NewInferenceEngineVersion.vue?vue&type=template&id=785f6a96"
import script from "./NewInferenceEngineVersion.vue?vue&type=script&lang=js"
export * from "./NewInferenceEngineVersion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports